import { render, staticRenderFns } from "./QuestionPictureChoiceItem.vue?vue&type=template&id=c6f255a4&scoped=true&lang=pug"
import script from "./QuestionPictureChoiceItem.vue?vue&type=script&lang=js"
export * from "./QuestionPictureChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionPictureChoiceItem.vue?vue&type=style&index=0&id=c6f255a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f255a4",
  null
  
)

export default component.exports